import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import TaxList from './Tax/TaxList'
import TaxTypeList from './TaxType/TaxTypeList'
import TaxTypeValueList from './TaxTypeValue/TaxTypeValueList'
import { useSelector } from 'react-redux'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'
import TaxMapping from './TaxMapping/TaxMapping'

const ManageTax = () => {
  const [activeToggle, setActiveToggle] = useState('taxList')
  const { pageAccess } = useSelector((state) => state.user)
  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  return checkPageAccess(
    pageAccess,
    allPages?.manageTax,
    allCrudNames?.read
  ) ? (
    <>
      {checkPageAccess(pageAccess, allPages?.manageTax, allCrudNames?.read) && (
        <div className='card overflow-hidden'>
          <div className='card-body p-0'>
            <div className='nav-tabs-horizontal nav nav-tabs'>
              <Link
                onClick={(e) => handleTabClick(e, 'taxList')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'taxList' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Tax
                  <hr />
                </span>
              </Link>
              <Link
                onClick={(e) => handleTabClick(e, 'TaxTypeList')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'TaxTypeList' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Tax Type
                  <hr />
                </span>
              </Link>
              <Link
                onClick={(e) => handleTabClick(e, 'TexMapping')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'TexMapping' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Tax Mapping
                  <hr />
                </span>
              </Link>
              <Link
                onClick={(e) => handleTabClick(e, 'TaxTypeValueList')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'TaxTypeValueList' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Tax Type Value
                  <hr />
                </span>
              </Link>
            </div>
          </div>

          <div className='tab-content p-3'>
            <div
              id='taxList'
              className={`tab-pane fade ${
                activeToggle === 'taxList' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'taxList' && <TaxList />}
            </div>

            <div
              id='TaxTypeList'
              className={`tab-pane fade ${
                activeToggle === 'TaxTypeList' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'TaxTypeList' && <TaxTypeList />}
            </div>

            <div
              id='TexMapping'
              className={`tab-pane fade ${
                activeToggle === 'TexMapping' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'TexMapping' && <TaxMapping />}
            </div>

            <div
              id='TaxTypeValueList'
              className={`tab-pane fade ${
                activeToggle === 'TaxTypeValueList' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'TaxTypeValueList' && <TaxTypeValueList />}
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <NotFound />
  )
}

export default ManageTax
